import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./components/Header";
import AdminSidebar from "./components/Sidebar";
import "../../css/admin/adminPanel.scss";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import apiClient from "../../api/clinet";

interface IListOfContents {
  title: string;
  postText: string;
  date: string;
  id: number;
}

type ContentType = "posts" | "gallery";

const AdminPanel: React.FC = () => {
  const [contents, setContents] = useState<IListOfContents[]>([]);
  const [displayContent, setDisplayContent] = useState<ContentType>("posts");
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const navigate = useNavigate();

  const fetchContents = async (type: ContentType) => {
    setLoading(true);
    setError(null);
    try {
      const endpoint = type === "posts" ? "/posts" : "/gallery";
      const response = await apiClient.get(endpoint);
      setContents(response.data);
    } catch (err) {
      setError("خطا در دریافت داده‌ها");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!displayContent) return;
    fetchContents(displayContent);
  }, [displayContent]);

  const handleDelete = async (id: number) => {
    if (window.confirm("آیا از حذف این مورد مطمئن هستید؟")) {
      try {
        await apiClient.delete(`/${displayContent}/${id}`);
        setContents((prev) => prev.filter((item) => item.id !== id));
      } catch {
        setError("خطا در حذف مورد");
      }
    }
  };

  return (
    <div className="panelContainer">
      <AdminSidebar />
      <div className="leftColumnAdmin">
        <Header />
        <div className="contentSelection">
          <label htmlFor="contents" className="label">
            انتخاب محتوا:
          </label>
          <select
            name="contents"
            id="contents"
            value={displayContent}
            onChange={(e) => setDisplayContent(e.target.value as ContentType)}
          >
            <option value="posts">پست‌ها</option>
            <option value="gallery">گالری تصاویر</option>
          </select>
        </div>
        <div className="listOfContents">
          {loading && <div className="loading">در حال بارگذاری...</div>}
          {error && <div className="error">{error}</div>}
          {!loading && !error && contents.length === 0 && (
            <div className="empty">موردی برای نمایش وجود ندارد.</div>
          )}
          {!loading &&
            !error &&
            contents.map((value) => (
              <div key={value.id} className="postContainer">
                <div className="postTitle">{value.title}</div>
                <div
                  className="postText"
                  dangerouslySetInnerHTML={{ __html: value.postText }}
                />
                <div className="dateEditContainer">
                  <div className="date">{value.date}</div>
                  <DeleteIcon
                    className="deleteIcon"
                    onClick={() => handleDelete(value.id)}
                  />
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
